
import { FolderOpenIcon } from '../Icons/FolderOpenIcon'
import { colors } from '../../styles/colors'
import { FolderIcon } from '../Icons/FolderIcon'
import { FileIcon } from '../Icons/FileIcon'
import {
    ArrowIconNew,
    StyledDot,
    StyledIconWrapper,
    StyledItemWrapper,
    StyledListItemText,
    StyledArrowWrapper,
    StyledTreeSubList
} from '../TreeList/treeList'
import { FolderOpenIconArrow } from '../Icons/FolderOpenIconArrow'
import { FolderIconArrow } from '../Icons/FolderIconArrow'
import { useTheme } from 'styled-components'
import { StyledContextMenu } from '../ContextMenu/StyledContextMenu'
import { ContextMenuTrigger } from 'react-contextmenu'
import PortalContextMenu from '../ContextMenu/PortalContextMenu'
import useStores from '../../stores/useStore'

const OfficeItem = ({
    office,
    setOfficesActive,
    onClick = () => ({}), //get chosen Office obj, 
    partialOffices,
    isClickable = office => office.isAllowToOrder,
    officesActive,
    renderExtraItemContent = (office) => null,
    parentsWithSelectedChildren = [], //folderIcon with arrow
    selectedOfficeId,
    setSelectedOfficeId,
    onParentOfficeClick = () => { },
    getContextMenuOptions = () => [],
    allowParentSelection
}) => {
    const theme = useTheme()
    const { officeStore } = useStores()

    const allowParentSelectionValue = allowParentSelection ?? officeStore.allowParentSelection

    const handleClickOffice = (office) => {
        if (!office) {
            console.warn("Undefined office clicked")
            return
        }
        if (office.isGroupItem && !allowParentSelectionValue) {
            if (typeof onParentOfficeClick === "function") {
                onParentOfficeClick()
            } else {
                console.warn("onParentOfficeClick is not a function")
            }
            return
        }
        onClick(office)
        setSelectedOfficeId(office.id)
    }

    const handleClickFolder = (officeId) => (e) => {
        e.stopPropagation()
        setOfficesActive((prevState) => ({
            ...prevState,
            [officeId]: !prevState[officeId],
        }))
    }

    // Get child offices for rendering in a nested list
    const getChildOffice = (office) => {
        return partialOffices.filter(child => child.parentOffice && child.parentOffice.id === office.id)
    }

    return (
        <>
            <StyledContextMenu>

                <ContextMenuTrigger id={`${office.id}_context`} holdToDisplay={-1}>
                    <StyledItemWrapper
                        isSelectable={!office.hasChildren} // Pass isSelectable to determine style and clickability
                        isInvalid={!isClickable(office)}
                        onClick={(e) => handleClickOffice(office)} style={office.id === selectedOfficeId ? { boxShadow: `inset 0px 0px 0px 2px  ${theme.primaryColor}` } : {}}
                    >
                        {office.hasChildren && (
                            <div className="d-flex" onClick={(e) => handleClickFolder(office.id)(e)}>
                                <StyledArrowWrapper>
                                    <ArrowIconNew
                                        color={officesActive[office.id] ? '#9c9c9c' : '#3a3a38'}
                                        variant={officesActive[office.id] ? 'down' : 'right'}
                                    />
                                </StyledArrowWrapper>
                                <StyledIconWrapper>
                                    {officesActive[office.id] ? (
                                        parentsWithSelectedChildren.includes(office.id) ? (
                                            <FolderOpenIconArrow color={colors.gray7} />
                                        ) : (
                                            <FolderOpenIcon color={colors.gray7} />
                                        )
                                    ) : parentsWithSelectedChildren.includes(office.id) ? (
                                        <FolderIconArrow color={colors.gray7} />
                                    ) : (
                                        <FolderIcon color={colors.gray7} />
                                    )}
                                </StyledIconWrapper>
                            </div>
                        )}
                        {!office.hasChildren && (
                            <div className="d-flex">
                                <StyledDot>•</StyledDot>
                                <StyledIconWrapper>
                                    <FileIcon uniqueId={`costcenter-icon-${office.id}`} color={colors.gray5} />
                                </StyledIconWrapper>
                            </div>
                        )}
                        <StyledListItemText>{office.displayName}</StyledListItemText>
                        {renderExtraItemContent(office)}
                    </StyledItemWrapper>

                    {office.hasChildren && officesActive[office.id] && (
                        // If the office has children and it's open, show child offices
                        <StyledTreeSubList>
                            {getChildOffice(office).map((childOffice) => (

                                <OfficeItem
                                    key={childOffice.id}
                                    office={childOffice}
                                    setOfficesActive={setOfficesActive}
                                    onClick={onClick}
                                    partialOffices={partialOffices}
                                    isClickable={isClickable}
                                    officesActive={officesActive}
                                    renderExtraItemContent={renderExtraItemContent}
                                    parentsWithSelectedChildren={parentsWithSelectedChildren}
                                    selectedOfficeId={selectedOfficeId}
                                    setSelectedOfficeId={setSelectedOfficeId}
                                    getContextMenuOptions={getContextMenuOptions}
                                    isSelectable={!childOffice.hasChildren}
                                    onParentOfficeClick={onParentOfficeClick}
                                    allowParentSelection={allowParentSelection}
                                />
                            ))}
                        </StyledTreeSubList>
                    )}
                </ContextMenuTrigger>
                {getContextMenuOptions(office).length ? (
                    <PortalContextMenu
                        contextId={`${office.id}_context`}
                        options={getContextMenuOptions(office)}
                    />
                ) : null}
            </StyledContextMenu>
        </>
    )
}

export default OfficeItem